import React, { useState } from "react";
import styles from "./OrderSummary.module.css";

const OrderSummary = ({ subtotal, taxes, total, setCurrentStep }) => {

  const [openPromoCode, setOpenPromoCode] = useState(false);
  const [invalidCode, setInvalidCode] = useState(false);

  const onApplyPromo = () => {
    setInvalidCode(true);
  }

  const onProcessOrder = () => {
    setCurrentStep(1)
  }

  return (
    <div className={styles.summaryContainer}>
      <div className={styles.container}>
        <h1 className={styles.title}>Total comandă</h1>
        <hr className={styles.divider} />
        <div className={styles.row}>
          <span>Subtotal:</span>
          <span>{subtotal.toString().replace(/\B(?=(\d{3})+(?!\d))/g, ".")} €</span>
        </div>
        <div className={styles.row}>
          <span>Taxe:</span>
          <span>{taxes.toString().replace(/\B(?=(\d{3})+(?!\d))/g, ".")} €</span>
        </div>
        <hr className={styles.divider} />
        <div className={`${styles.row} ${styles.totalRow}`}>
          <span>Total:</span>
          <span>{total.toString().replace(/\B(?=(\d{3})+(?!\d))/g, ".")} €</span>
        </div>
        <div className={styles.processContainer}>
          {
            (openPromoCode)
              ? (
                <div>
                  <div className={styles.promoContainer}>
                    <input
                      type="text"
                      placeholder="cod..."
                      className={styles.input}
                    />
                    <button className={styles.button} onClick={onApplyPromo}>Aplică</button>
                  </div>
                  {(invalidCode) && <span className={styles.invalidText}>Acest promocod nu este disponibil.</span>}
                </div>
              )
              : (<button className={styles.promoButton} onClick={() => setOpenPromoCode(true)}>Am un cod promoțional</button>)

          }
          <button className={styles.processButton} onClick={onProcessOrder}>Procesare</button>
        </div>
      </div>
    </div>
  );
};

export default OrderSummary;
